import { instana } from "@crystal/analytics";
const FrontendName = "AccountPortal";
const Events = {
  PortalInlineView: "AccountPortal_InlineView",
  PortalOpened: "AccountPortal_Opened",
  PortalClosed: "AccountPortal_Closed",
  SocialLoginStart: "SocialLogin_Start",
  ExternalAuthProcess: "ExternalAuth_Process",
  ExternalAuthSuccess: "ExternalAuth_Success",
  ExternalAuthError: "ExternalAuth_Error"
};
function instanaEvent(event, meta) {
  instana("page", (meta == null ? void 0 : meta.pageName) || FrontendName);
  instana("reportEvent", event, {
    meta: {
      ...meta
    }
  });
}
export {
  Events,
  FrontendName,
  instanaEvent
};
//# sourceMappingURL=monitoring.js.map
